module.exports = __webpack_public_path__ + "static/media/dog_02.b4be407a.jpg";